<template>
	<div>
		<router-view v-show="$route.matched.length == 3"></router-view>
		<PageHeaderLayout v-show="$route.matched.length == 2">
			<div class="main-page-content" v-loading='loadingStaus'>

				<div class="search">
					<el-form size="medium" :inline="true" :model="searchCondition" class="demo-form-inline">
						<el-form-item label="商户名称:">
							<el-input placeholder="请输入内容" :value="nowCompany.name" :readonly="true"></el-input>
						</el-form-item>
						<el-form-item label="统计时间:">
							<el-date-picker v-model="searchCondition.day" value-format="yyyy-MM-dd" format="yyyy-MM-dd"
								type="daterange" align="right" unlink-panels range-separator="至"
								start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions">
							</el-date-picker>
						</el-form-item>

						<el-form-item>
							<el-button type="primary" @click="searchButton">查询</el-button>
                         
							<el-button v-if="userPermissions.indexOf('dailyStatistics_export')>-1" style="margin: 0 0 0px 20px" type="primary" size="medium" icon="el-icon-document"
								@click="handleBeforeDownload">
								导出
							</el-button>
						</el-form-item>
					</el-form>

				</div>
				<div class="data-content">
					<!-- <table id="customers">
						<tr>
							<th>统计日期</th>
							<th>商户名称</th>
							<th>充值金额</th>
							<th>发放金额</th>
							<th>服务费</th>
						</tr>
						<tr v-for="item in 10" :key="item">
							<td>2022-09-27</td>
							<td>薪龙网</td>
							<td>1000000</td>
							<td>100000</td>
							<td>100000</td>
						</tr>
					</table> -->
					<ApeTable ref="apeTable" style="font-size: 12px" :data="tableData" :columns="tableCol"
						:loading="false" :pagingData="pagingData" @switchPaging="switchPaging" highlight-current-row>
					</ApeTable>
				</div>
			</div>
		</PageHeaderLayout>

	</div>
</template>

<script>
	import moment from "moment";
	import PageHeaderLayout from '@/layouts/PageHeaderLayout';
	import ApeTable from '@/components/ApeTable';



	import {
		mapGetters
	} from 'vuex';

	export default {
		components: {
			PageHeaderLayout,
			ApeTable,
		},

		data() {
			return {
				nowCompany: localStorage.getItem('nowCompany') ? JSON.parse(localStorage.getItem('nowCompany')) : {},
				pickerOptions: {
					shortcuts: [{
						text: '最近一周',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
							picker.$emit('pick', [start, end]);
						}
					}, {
						text: '最近一个月',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
							picker.$emit('pick', [start, end]);
						}
					}, {
						text: '最近三个月',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
							picker.$emit('pick', [start, end]);
						}
					}]
				},
				// 搜索条件
				searchCondition: {

					day: '',
				},
				loadingStaus: false,
				merchant_option: [],
				tableCol: [{
					title: '统计日期',
					value: 'day',
					header_align: 'center',
					align: 'center'
				}, {
					title: '商户名称',
					value: 'company_name',
					header_align: 'center',
					align: 'center'
				}, {
					title: '充值金额',
					value: 'recharge_money',
					header_align: 'center',
					align: 'center'
				}, {
					title: '发放金额',
					value: 'withdraw_money',
					header_align: 'center',
					align: 'center'
				}, {
					title: '服务费',
					value: 'tax_money',
					header_align: 'center',
					align: 'center'
				}],
				tableData: [],
				// 分页信息
				pagingData: {
					is_show: true,
					layout: 'total, sizes, prev, pager, next, jumper',
					total: 0,
					page_size: 9999999999
				},
			};
		},

		computed: {
			...mapGetters(['userPermissions', 'dailyStatistics_export']),

		},
		watch: {
			'$route.matched': function(n, o) {
				console.log(o);
				if (n.length === 2) {
					this.init();
				}
			}
		},
		methods: {

			//查询选中的数据
			searchButton() {
				this.init()
			},
			/* 导出点击 */
			async handleBeforeDownload() {
				let search = {
					...this.searchCondition
				}
				console.log()
				if (search.day) {
					search.time = {
						start_time: search.day[0],
						end_time: search.day[1]
					}

				}
				delete search.day
				let {
					list
				} = await this.$api.getStatisticsday({
					...search,
					page_size: 9999999999,
					current_page: 1
				});
				this.handleDownload(list)
			},
			//导出
			async handleDownload(list) {
				import('@/excel/Export2Excel').then(excel => {
					let tHeader = ['统计日期', '商户名称', '充值金额', '发放金额', '服务费'];

					const data = this.formatJson(list);

					let filename = `每日统计(${this.searchCondition?.day?.join('至')||'全部日期'})`;
					excel.export_json_to_excel({
						header: tHeader, //Header Required
						data, //Specific data Required
						filename: filename, //Optional
						autoWidth: true, //Optional
						bookType: "xlsx" //Optional
					});
					this.downloadLoading = false;

				});
			},
			formatJson(jsonData) {
				console.log(jsonData)
				return jsonData.map(v => {

					let {
						day,
						company_name,
						recharge_money,
						withdraw_money,
						tax_money

					} = v;
					return [day, company_name, recharge_money, withdraw_money, tax_money

					];
				});
			},
			// 切换页码操作
			async switchPaging() {
				this.init();
			},
			async init() {
				this.loadingStaus = true
				try {
					let pagingInfo = this.$refs['apeTable']?.getPagingInfo() || {
						page_size: 9999999999,
						current_page: 1
					};
					let search = {
						...this.searchCondition
					}
					if (search.day) {
						search.time = {
							start_time: search.day[0],
							end_time: search.day[1]
						}	
					}
					delete search.day
					let parms = {
						...pagingInfo,
						...search
					}

					let {
						list,
						pages
					} = await this.$api.getStatisticsday(parms);
					this.tableData = list
					this.pagingData.total = pages.total;
					this.offset = pages.offset;
				} catch (e) {
					console.log(e)
				} finally {
					setTimeout(() => {
						this.loadingStaus = false
					}, 300)
				}

			}
		},

		created() {
			const end = new Date();
			const start = new Date();
			start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
			end.setTime(end.getTime() - 3600 * 1000 * 24 * 1);
			this.searchCondition.day = [moment(start).format('YYYY-MM-DD'), moment(end).format('YYYY-MM-DD')]
		},
		mounted() {
			this.init()
		}
	};
</script>

<style lang="scss" scoped>
	.data-content {
		margin-top: 30px;
	}

	#customers {
		font-family: Arial, Helvetica, sans-serif;
		border-collapse: collapse;
		width: 100%;
	}

	#customers td,
	#customers th {
		border: 1px solid #ddd;
		padding: 8px;

		text-align: center;
	}

	#customers td {
		height: 40px;
	}

	#customers tr:nth-child(even) {
		background-color: #f2f2f2;
	}

	#customers tr:hover {
		background-color: #ddd;
	}

	#customers th {
		padding-top: 12px;
		padding-bottom: 12px;

		background-color: #4CAF50;
		color: white;
	}
</style>
